import { I18nService } from "@perxis-auto/shared/lib";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
const GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES = () => {
  const { i18n } = I18nService.getInstance();
  return [
    {
      id: "engine",
      path: "engine",
      label: i18n.t("config.specification.engine", { ns: APP.name }),
      formatter: (values) => {
        if (!Array.isArray(values)) {
          return values;
        }
        return values.filter((value) => value !== null).join(", ");
      }
    },
    { id: "gearbox", path: "gearbox", label: i18n.t("config.specification.gearbox", { ns: APP.name }) },
    { id: "drivetrain", path: "drivetrain", label: i18n.t("config.specification.drivetrain", { ns: APP.name }) },
    { id: "version", path: "version", label: i18n.t("config.specification.version", { ns: APP.name }) },
    {
      id: "productionDate",
      path: "productionDate",
      label: i18n.t("config.specification.productionDate", { ns: APP.name }),
      formatter: (value) => {
        if (Array.isArray(value)) {
          return "";
        }
        const productionDate = new Date(value);
        return productionDate.getFullYear();
      }
    }
  ];
};
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  schemes: GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES()
});
export {
  GET_DEFAULT_CONTAINER_PROPS,
  GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES
};
